import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DeleteOrgUserMutation,
  DeleteOrgUserMutationVariables,
} from "./DeleteOrgUser.generated";

const DELETE_ORG_USER: TypedDocumentNode<
  DeleteOrgUserMutation,
  DeleteOrgUserMutationVariables
> = gql`
  mutation deleteOrgUser($orgUuid: String!, $userUuid: String!) {
    deleteOrgUser(orgUuid: $orgUuid, userUuid: $userUuid) {
      ok
    }
  }
`;

export default DELETE_ORG_USER;
